import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "upload_path",
  "use": "upload_path-usage",
  "viewBox": "-5 -1 214 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"-5 -1 214 32\" id=\"upload_path\"><rect width=\"211\" height=\"30\" fill-rule=\"evenodd\" stroke=\"#fdb53a\" stroke-linejoin=\"bevel\" stroke-width=\"2\" rx=\"13\" ry=\"13\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol